<template>
  <Modal v-if="visible" @close="$emit('close')" width="720px">
    <h2 style="margin-bottom: 32px; text-align: center">{{ title }}</h2>
    <VTable
      :columns="columns"
      :items="sortedRows"
      items-type="array"
      :sort-api="onSort"
    />
    <div style="margin-top: 16px">
      <Button
        width="100%"
        height="40px"
        text="Закрыть"
        class="btn-secondary"
        @click.native.prevent="$emit('close')"
      />
    </div>
  </Modal>
</template>

<script>
import Vue from "vue";
import Modal from "@/components/Modals/Modal.vue";
import VTable from "@/components/Table/VTable.vue";
import Button from "@/components/Button.vue";

export default Vue.extend({
  name: "OrderPassangersModal",
  components: { Modal, VTable, Button },
  props: {
    visible: { type: Boolean, default: false },
    rows: { type: Array, default: () => [] },
    title: { type: String, default: "Пассажиры" },
    defaultSort: {
      type: Object,
      default: () => ({ key: "fio", direction: "asc" }),
    },
  },
  data() {
    return {
      sort: { key: this.defaultSort.key, direction: this.defaultSort.direction },
    };
  },
  watch: {
    defaultSort: {
      handler(v) {
        if (!v) return;
        this.sort = { key: v.key || "fio", direction: v.direction || "asc" };
      },
      deep: true,
    },
  },
  computed: {
    columns() {
      return [
        { title: "ФИО", value: "fio", sort: true },
        { title: "Подразделение", value: "department", sort: true },
        { title: "Филиал", value: "filiation", sort: true },
      ];
    },
    sortedRows() {
      const idx = this.columns.findIndex((c) => c.value === this.sort.key);
      const compare = (a, b) =>
        (a ?? "-").localeCompare(b ?? "-", "ru", { sensitivity: "base" });
      const dir = this.sort.direction === "asc" ? 1 : -1;
      const rows = Array.isArray(this.rows) ? this.rows.slice() : [];
      if (idx < 0) return rows.sort((a, b) => compare(a[0], b[0]));
      return rows.sort((a, b) => dir * compare(a[idx], b[idx]));
    },
  },
  methods: {
    onSort(column, asc) {
      const key = column?.value;
      if (!key) {
        this.sort = { key: "fio", direction: "asc" };
        return;
      }
      this.sort = { key, direction: asc ? "asc" : "desc" };
    },
  },
});
</script>
